import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error(
        "Supabase credentials missing. The application will not function correctly until VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set in your environment variables.",
    );
}

// Initialize with empty strings if missing to avoid immediate constructor error, 
// though Supabase client usually handles this gracefully with a warning.
export const supabase = createClient(
    supabaseUrl || "https://placeholder-url.supabase.co",
    supabaseAnonKey || "placeholder-key",
);
